const createSite = {
  form: {
    header: {
      title: 'Hello,',
    },

    fields: {
      sitePlaceHolder: 'Please, fill your site\'s name',
    },

    footer: {
      confirmButtonText: {
        create: 'Submit',
        update: 'Submit',
      },
    },

    information: {
      details: {
        header: 'What scenario would you like to stream with moovex?',
        instructions: 'Please, check the field that describes your zone of business the most.',
      },
    },

    button: 'I WANT TO BUILD A SCENARIO',
  },
};

export default createSite;
